/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from "react";

import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { Document } from "@contentful/rich-text-types";

import { TopicIntroduction } from "@/templates/agile-hub/types";

import {
    TopicIntroductionContent,
    UniformTopicIntroductionContentProps
} from "./src/topic-introduction-content";

export type { UniformTopicIntroductionContentProps } from "./src/topic-introduction-content";

export const format = (
    body: UniformTopicIntroductionContentProps
): TopicIntroduction => {
    if (!body)
        return {
            title: null,
            details: null,
            asset: null,
            embedLink: null
        };

    const { topicintroduction }: any = body;

    function getRichText(richText: string | Document) {
        if (typeof richText === "string") {
            return richText;
        }

        return documentToHtmlString(richText);
    }

    const formattedBody: TopicIntroduction = {
        title: topicintroduction?.topicIntroductionTitleExternal ?? null,
        details:
            getRichText(topicintroduction?.topicIntroductionDetails) ?? null,
        asset: (() => {
            const formattedAsset = formatAsset(
                topicintroduction?.topicIntroductionAsset?.[0]
            );
            return formattedAsset ? [formattedAsset] : null;
        })(),
        embedLink: topicintroduction?.embedLink ?? null
    };

    return formattedBody;
};

// eslint-disable-next-line complexity
const formatAsset = (asset: any) => {
    if (!asset?.fields) return undefined;

    const { fields } = asset;
    return {
        name: fields.title,
        size: fields.file?.details?.size,
        fileName: fields.file?.fileName ?? null,
        height: fields.file?.image?.height ?? null,
        width: fields.image?.width ?? null,
        url: fields.file?.url,
        description: fields.description ?? null,
        contentType: fields.file?.contentType ?? null
    };
};

const UniformTopicIntroductionContent = (
    props: UniformTopicIntroductionContentProps
) => {
    const topicIntroduction = useMemo(() => format(props), [props]);

    return <TopicIntroductionContent topicIntroduction={topicIntroduction} />;
};

export default UniformTopicIntroductionContent;
